"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = livedInSameStateSince;

var _dateFns = require("date-fns");

var _sortFillAddressesDates = _interopRequireDefault(require("./sortFillAddressesDates"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function livedInSameStateSince() {
  var unorderedAddresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _dateFns.subYears)(new Date(), 2);
  var addresses = (0, _sortFillAddressesDates["default"])(unorderedAddresses); // Get all addresses that overlap with time gap

  var statesInTimeSpan = addresses.reduce(function (adds, add) {
    if (add.startedAt && (0, _dateFns.isValid)(new Date(add.startedAt)) && (add.endedAt == null || (0, _dateFns.isValid)(new Date(add.endedAt))) && (0, _dateFns.areIntervalsOverlapping)({
      start: since,
      end: new Date()
    }, {
      start: new Date(add.startedAt),
      end: add.endedAt ? new Date(add.endedAt) : new Date()
    })) {
      return adds.concat(add.state);
    }

    return adds;
  }, []);
  var statesLivedIn = Array.from(new Set(statesInTimeSpan)).length;
  return statesLivedIn <= 1;
}